import Schema from 'async-validator';

export const configureAsyncValidator = () => {
  Schema.warning = () => {};
};
